@if (stepperReady && steps.length) {
  <mat-stepper
    linear
    labelPosition="bottom"
    (selectionChange)="onStepChange($event)"
    class="stepper"
  >
    @for (step of steps; track step) {
      <mat-step
        [label]="step.label"
        [stepControl]="step.formGroup"
        [completed]="step.completed()"
      >
        <ng-template matStepLabel>
          <p class="custom-step-label">{{ step.label }}</p>
          <p class="application-info">{{ step.description }}</p>
        </ng-template>
      </mat-step>
    }
  </mat-stepper>
}
